import { createFileRoute } from '@tanstack/react-router'
import { guardAdminOnly } from '@/lib/auth/routeGuards'
import AttestationManagement from '@/components/adminPage/attestation/AttestationManagement'
import { AttestationTour } from '@/tour/admin'

export const Route = createFileRoute('/admin/attestation')({
  beforeLoad: guardAdminOnly,
  component: AttestationRoute,
})

function AttestationRoute() {
  return (
    <>
      <AttestationManagement />
      <AttestationTour />
    </>
  )
}



